import { ResponseType } from "../../types/apiTypes";

export function ismodalMobileSegregate(item: any): boolean {
  const modalList = [ResponseType.ApplyForm];
  return modalList.includes(item?.type);
}

export function ismodalDesktopSegregate(item: any): boolean {
  const modalList = [
    ResponseType.Video,
    ResponseType.Blog,
    ResponseType.WebLink,
    ResponseType.ApplyForm,
  ];
  return modalList.includes(item?.type);
}

export function segregateApiResponse(
  response: any[],
  isMobile: boolean
): { messages: any[]; modalConfig: any[] } {
  const messages: any[] = [];
  const modalConfig: any[] = [];

  response.forEach((item) => {
    if (isMobile && ismodalMobileSegregate(item)) {
      modalConfig.push(item);
    } else if (!isMobile && ismodalDesktopSegregate(item)) {
      modalConfig.push(item);
    } else {
      messages.push(item);
    }
  });

  return { messages, modalConfig };
}
